import React, {PropTypes} from 'react';


function EmailIcon(props) {
  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg width="32px" height="30px" viewBox="0 0 32 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="2712---Emails" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="2712---Emails-1" transform="translate(-744.000000, -181.000000)">
              <g id="Group-27" transform="translate(744.000000, 181.000000)">
                  <path d="M15.55,30 C6.97573,30 0,23.271 0,15 C0,6.729 6.97573,0 15.55,0 C24.12427,0 31.1,6.729 31.1,15 C31.1,23.271 24.12427,30 15.55,30 L15.55,30 Z M15.55,2 C8.11917333,2 2.07333333,7.832 2.07333333,15 C2.07333333,22.168 8.11917333,28 15.55,28 C22.9808267,28 29.0266667,22.168 29.0266667,15 C29.0266667,7.832 22.9808267,2 15.55,2 L15.55,2 Z" id="Shape-Copy" fill="#4A4A4A"></path>
                  <g id="Group-18" transform="translate(8.000000, 10.000000)" stroke="#4A4A4A" strokeWidth="1.2" strokeLinejoin="round">
                      <path d="M14.5,10 L0.5,10 C0.224,10 0,9.776 0,9.5 L0,0.5 C0,0.224 0.224,0 0.5,0 L14.5,0 C14.776,0 15,0.224 15,0.5 L15,9.5 C15,9.776 14.776,10 14.5,10 Z" id="Shape"></path>
                      <polyline id="Shape" strokeLinecap="round" points="0 1 7.5 6 15 1"></polyline>
                  </g>
              </g>
          </g>
      </g>
    </svg>
  );
}


EmailIcon.propTypes = {
  className: PropTypes.string
};

export default EmailIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/EmailIcon.js